/* eslint-disable */
import { useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import img from '../../assets/images/error.svg'
import { Button } from '../../components/core/button'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const Error = ({ className }) => {
  const { language } = useContext(PageContext)
  const DEFAULT_DATA = {
    title: {
      AZ: 'Səhifə tapılmadı',
      ENG: 'Page Not Found',
      RU: 'Страница не найдена',
      TR: 'Sayfa Bulunamadı',
    },
    description_az: 'Axtardığınız səhifə mövcud deyil və ya ünvan dəyişdirilmişdir.',
    description_eng: 'The page you are looking for does not exist or has been moved.',
    description_ru: 'Страница, которую вы ищете, не существует или была перемещена.',
    description_tr: 'Aradığınız sayfa mevcut değil veya taşınmış olabilir.',
  }
  const [load, setLoad] = useState(true)
  const [data, setData] = useState(DEFAULT_DATA)
  useEffect(() => {
    (async () => {
      try {
        const res = await PagesAPI.getError()
        if (res?.data?.title) {
          setData(res.data)
        }
      } catch (e) {
        console.warn('Using default 404 error data')
      }
    })()
  }, [])
  const home = {
    AZ: 'Ana Səhifə',
    ENG: 'Home',
    RU: 'Главная страница',
    TR: 'Ana Sayfa',
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <div>
        <figure style={{ backgroundImage: `url('${img}')` }} />
        <h1>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</h1>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <Button to={'/'}>{home[language] || home.TR || home.AZ}</Button>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Error
